import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

const tableName = Constants.enums.TABLES_NAME_ENUM.RXDB_SCHEMAS_TABLE;

async function getRxDBSchemas(queryParams = {}) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        fetchAll: true,
        queryParams
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getRxDBSchemas
};
